// extracted by mini-css-extract-plugin
export default {"titleContainer":"styles_titleContainer__XUtuQ"};